import {useMutation} from 'react-query';
import {countriesService} from '../../../../shared/services/configuration/countries';
import {IRegionQuery} from '../../../../shared/services/configuration/countries/dtos/region-query';

export const useGetCountryRegions = (regionQuery: IRegionQuery) => {
  return useMutation(
    () => {
      return countriesService.regionsList(regionQuery);
    },
    {
      mutationKey: ['allCountries', regionQuery],
    },
  );
};
